import dynamic from 'next/dynamic';

import SubscribePopup from './SubscribePopup';

const VisaFree = dynamic(() => import('./VisaFree').then((mod) => mod.default));

const Subscribe = dynamic(() =>
  import('./Subscribe').then((mod) => mod.default)
);

const FirstMeetingSurveyForm = dynamic(() =>
  import('./FirstMeetingSurvey').then((mod) => mod.default)
);

const Quiz = dynamic(() =>
  import('./QuizCaribbean/QuizCaribbeanRenderQuestions').then(
    (mod) => mod.default
  )
);

const Quiz2 = dynamic(() =>
  import('./QuizCaribbean/QuizCaribbeanResult').then((mod) => mod.default)
);

const DynamicQuiz = dynamic(() =>
  import('./DynamicQuiz/QuizRenderQuestions').then((mod) => mod.default)
);

const Unsubscribe = dynamic(() =>
  import('./Unsubscribe').then((mod) => mod.default)
);

const ProgramSelectorRenderQuestions = dynamic(() =>
  import('./ProgramSelector/ProgramSelectorRenderQuestions').then(
    (mod) => mod.default
  )
);

const ProgramSelectorResult = dynamic(() =>
  import('./ProgramSelector/ProgramSelectorResult').then((mod) => mod.default)
);

export const customVariants = {
  VisaFree: VisaFree,
  SubscribePopup: SubscribePopup,
  Subscribe: Subscribe,
  FirstMeetingSurvey: FirstMeetingSurveyForm,
  Quiz: Quiz,
  Quiz2: Quiz2,
  DynamicQuiz,
  Unsubscribe: Unsubscribe,
  // для подборщика  использется две формы, одна для вопросов, вторая для результата
  //эта форма нужна только для вопросов в квизе, на выходе отдает id следующей формы
  ProgramSelectorRenderQuestions: ProgramSelectorRenderQuestions,
  //эта форма нужна только для результата квиза, где показывается результат, и поля для ввода контактов из другой формы
  ProgramSelectorResult: ProgramSelectorResult,
};
